import { connect } from 'react-redux';
import { Action } from 'redux';

import { AppState } from '../../app/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../app/utils/ConnectUtils';

import { SessionSiteSelectors, SessionUserSelectors } from '../../app/selectors/SessionInfoSelectors';
import { SiteRoles } from '../../ts/ServerApi/types/ISiteRole';
import { homeCloseWelcomeChannelAction } from '../actions/HomeActions';
import { selectShowDefaultWelcomeChannelFromAppState, selectWelcomeChannelFooterFromAppState } from '../selectors/HomeSelectors';
import { WelcomeChannelProps } from '../utils/WelcomeChannelPropsByRole';
import { WelcomeChannel, WelcomeChannelDispatchProps, WelcomeChannelStateProps } from './WelcomeChannel';

export const mapStateToProps: MapStateToProps<WelcomeChannelStateProps> = (state: AppState) => {
  const userRole = getRole(state);
  const webAuthoringEnabled = SessionUserSelectors.canAuthorOnWeb(state);

  const welcomeChannelProps = {
    ...WelcomeChannelProps.getPropsByRole(userRole, webAuthoringEnabled),
    showDefaultWelcomeChannel: selectShowDefaultWelcomeChannelFromAppState(state),
    footer: selectWelcomeChannelFooterFromAppState(state),
  };

  return welcomeChannelProps;
};

export const mapDispatchToProps: MapDispatchToProps<WelcomeChannelDispatchProps> = (dispatch) => ({
  closeWelcomeChannel: () => {
    dispatch(homeCloseWelcomeChannelAction());
  },
  dispatchAction: (action: Action) => dispatch(action)
});

/**
 * Some logic to account for weird behavior where Server Admins have a "Creator" role from getSessionInfo.
 */
function getRole(state: AppState): string {
  if (SessionUserSelectors.isSessionServerAdmin(state)) {
    return SiteRoles.ServerAdministrator;
  } else {
    return SessionSiteSelectors.siteRole(state);
  }
}

export const ConnectedWelcomeChannel = connect(mapStateToProps, mapDispatchToProps)(WelcomeChannel);
